import React, { Fragment } from 'react';
import PropTypes from 'prop-types';


const FeedbackMessages = ({
  updatingBundle, showBundleFullErrorMessage,
  showBundleUpdateErrorMessage, showBundleUpdateSuccessfulMessage, headerLabelRef
}) => (
  <>
    <div
      className={`feedback feedback-error ${!updatingBundle && showBundleFullErrorMessage
        ? 'display-feedback' : ''}`}
    >
      You reached the maximum of accessories for a bundle
    </div>
    <div
      className={`feedback feedback-error ${!updatingBundle && showBundleUpdateErrorMessage
        ? 'display-feedback' : ''}`}
    >
      Error while updating the bundle
    </div>
    <div
      className={`feedback ${updatingBundle
        ? 'display-feedback' : ''}`}
    >
      Updating bundle...
    </div>
    <div
      className={`feedback feedback-ok ${!updatingBundle && showBundleUpdateSuccessfulMessage
        ? 'display-feedback' : ''}`}
    >
      <a
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          headerLabelRef.current.scrollIntoView({ behavior: 'smooth' });
        }}
      >
        Update successful! click here to view your bundle
      </a>
    </div>
  </>
);

FeedbackMessages.propTypes = {
  updatingBundle: PropTypes.bool.isRequired,
  showBundleFullErrorMessage: PropTypes.bool.isRequired,
  showBundleUpdateErrorMessage: PropTypes.bool.isRequired,
  showBundleUpdateSuccessfulMessage: PropTypes.bool.isRequired,
  headerLabelRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }).isRequired
};

export default FeedbackMessages;
